<template>
  <!-- 업체물품 반입 신청 현황 -->
  <div>
    <v-card class="ma-4" id="head_height">
      <v-toolbar dense flat color="white">
        <v-toolbar-title class="font-weight-bold">
          <v-icon class="mr-2">mdi-view-list-outline</v-icon>업체물품 반입 신청 현황
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn @click="Initialize();" icon small>
          <v-icon>
            refresh
          </v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider class="ml-4 mr-4"></v-divider>
      <v-card-text class="mt-2">
        <v-row>
          <v-col cols="12" sm="6" md="3" lg="12" class="d-flex">
            <div class="d-flex mb-n6">
              <IronDate ref="IronDateRef" v-model="sNowSelectDate" cLabel="신청일" @update="onDateRangeChange" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <IronDate ref="IronDateRef" v-model="sCarryNowSelectDate" cLabel="반입일" @update="onCarryDateRangeChange" style="width:230px;" class="mr-4 hidden-md-and-down"/>
              <v-select
                :items="zCarrySort"
                v-model="cSort"
                @change="GetCorCarryLog()"
                class="mr-4 hidden-md-and-down"
                style="width:120px;"
                label="구분"
                dense
                hide-details
              ></v-select>
              <v-select
                :items="zCarryState"
                v-model="cState"
                @change="GetCorCarryLog()"
                class="mr-4 hidden-md-and-down"
                style="width:120px;"
                label="상태"
                dense
                hide-details
              ></v-select>
              <v-text-field
                v-model="cNowSearchkeyWord"
                @keyup.enter="GetCorCarryLog()"
                @click:append="GetCorCarryLog()"
                append-icon="search"
                label="검색어"
                placeholder="이름 or 소속 or 담당자"
                class="hidden-md-and-down"
                style="width:210px;"
                dense
                hide-details
                persistent-placeholder
              ></v-text-field>
            </div>
            <IronDate ref="IronDateRef" v-model="sNowSelectDate" cLabel="신청일" @update="onDateRangeChange" style="width:100%;" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-2">
            <IronDate ref="IronDateRef" v-model="sCarryNowSelectDate" cLabel="반입일" @update="onCarryDateRangeChange" style="width:100%;" class="hidden-lg-and-up"/>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="d-flex order-sm-1">
            <v-select
              :items="zCarrySort"
              v-model="cSort"
              @change="GetCorCarryLog()"
              class="mr-1 hidden-lg-and-up"
              label="구분"
              dense
              hide-details
            ></v-select>
            <v-select
              :items="zCarryState"
              v-model="cState"
              @change="GetCorCarryLog()"
              class="ml-1 hidden-lg-and-up"
              label="상태"
              dense
              hide-details
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="order-sm-3">
            <v-text-field
              v-model="cNowSearchkeyWord"
              @keyup.enter="GetCorCarryLog()"
              @click:append="GetCorCarryLog()"
              append-icon="search"
              label="검색어"
              placeholder="이름 or 소속 or 담당자"
              class="hidden-lg-and-up"
              dense
              hide-details
              persistent-placeholder
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <v-card class="ma-4" v-resize="onResize">
      <v-data-table
        :items="Records"
        :headers="headers"
        v-model="selected"
        :single-select="bSingleSelect"
        @click:row="handleClick"
        @dblclick:row="handleDoubleClick(selected[0])"
        :items-per-page="15"
        item-key="cReqId"
        :height="ChangableHeight"
        fixed-header
      >
        <template v-slot:item.cCreateDateTime="{ item }">
          {{item.cCreateDateTime.substring(0,10)}}
        </template>
        <template v-slot:item.cLabel="{ item }">
          {{getLabel(item.cLabel)}}
        </template>
        <template v-slot:item.cZone="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div
                style="max-width:220px;min-width:150px;"
                class="text-truncate"
                v-bind="attrs"
                v-on="on"
              >
                {{item.cZone}}
              </div>
            </template>
            <div style="max-width:300px;">{{item.cZone}}</div>
          </v-tooltip>
        </template>
        <template v-slot:item.cSort="{ item }">
          <v-chip label small :color="getSortColor(item.cSort)" dark>{{getSort(item.cSort)}}</v-chip>
        </template>
        <template v-slot:item.cCarryInDate="{ item }">
          {{item.cCarryInDate.substring(0,10)}}
        </template>
        <template v-slot:item.cCarryOutDate="{ item }">
          <div v-if="item.cSort != '2'">{{item.cCarryOutDate.substring(0,10)}}</div>
        </template>
        <template v-slot:item.cState="{ item }">
          <v-chip label small :color="getStateColor(item.cState)" dark>{{getState(item.cState)}}</v-chip>
        </template>
        <template v-slot:item.cElapsedDate="{ item }">
          <div>{{getElapsedDate(item.cCreateDateTime)}}</div>
        </template>
        <template v-slot:item.cEndComment="{ item }">
          <v-btn v-if="((item.cCustomId == CustomInfo.CustomId) || (item.cCustomId != CustomInfo.CustomId && CustomInfo.Manager != 'N')) && item.cState != 'R'" @click="ShowComment(item,item.cState)" icon><v-icon>mdi-account-details-outline</v-icon></v-btn>
        </template>
        <template v-slot:item.cEdit="{ item }">
          <div v-if="item.cCustomId == CustomInfo.CustomId && item.cState == 'R'" class="d-flex">
            <v-btn @click="OpenDialog(item)" icon><v-icon>mdi-pencil</v-icon></v-btn>
            <v-btn @click="ShowDelDialog(item)" icon><v-icon>delete</v-icon></v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="black--text">{{cNoMsg}}</div>
        </template>
      </v-data-table>
    </v-card>


    <EditCarryDialog ref="EditCarryDialogRef" @ChangeCorCarryLog="UpdateCorCarryLog" />
    <DelDialog ref="DelDialogRef" @DelCarryData="DelCarryData"/>
    <ResponseDialog ref="ResponseDialogRef"/>
  </div>
</template>

<script>
import BasicInfo from "@/BasicInfo.js";
import axios from "axios";
import EventBus from "@/eventBus.js";
import {mapState} from "vuex";

import IronDate from '@/components/iron28Calendar/src/IronDate3.vue';
import Util from "../Util.js";

import EditCarryDialog from '../components/EditCarryDialog.vue'
import DelDialog from '../components/DelDialog.vue'
import ResponseDialog from '../components/ResponseDialog.vue'

export default {
  components: {
    IronDate,
    EditCarryDialog,
    DelDialog,
    ResponseDialog,
  },
  data: () => ({
    bSingleSelect : true,
    bApplyDate : false,
    date2 : new Date(Util.sFormatDate(Date())),
    sStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    sNowSelectDate : Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    sCarryStartDate : Util.sFormatDate(Util.sBefore1Moth()),
    sCarryEndDate : Util.sFormatDate(Util.sAfter1Moth()),
    sCarryNowSelectDate : Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth()),
    ChangableHeight : "",
    cNowSearchkeyWord : "",
    cNoMsg : "",
    cState : "ALL",
    cSort : "ALL",
    selected : [],
    Records : [],
    headers : [
      { text: 'No', value: 'sNum', width : "10"},
      { text: '신청일', value: 'cCreateDateTime',width: "120" },
      { text: '담당자', value: 'cUserNm',width: "120" },
      { text: '반입물품', value: 'cLabel' ,width : "120"},
      { text: '반입건물', value: 'cZone'},
      { text: '반·출입증번호', value: 'cCarryDocNum',align : "center", width : "180"},
      { text: '구분', value: 'cSort', width : "80", align : "center" },
      { text: '반입예정일', value: 'cCarryInDate' , width: "120", align : "center" },
      { text: '반출예정일', value: 'cCarryOutDate' , width: "120", align : "center" },
      { text: '상태', value: 'cState', width : "80", align : "center" },
      { text: '경과일자', value: 'cElapsedDate', width : "80", align : "center" },
      { text: '의견', value: 'cEndComment',width:"80",align : "center"},
      { text: '작업', value: 'cEdit', width : "80", align : "center" },
    ],
  }),
  computed: {
    ...mapState(["CustomInfo","zCarryState","zCarrySort","zCarryItem"]),
  },
  created() {
  },

  mounted() {
    this.Initialize();
    this.onResize();
  },

  methods : {
    onResize(){
      let h1 = document.getElementById('footer_height').clientHeight
      let h2 = document.getElementById('head_height').clientHeight

      let iCalcHeight = window.innerHeight - h1 - h2 - 136

      if (iCalcHeight >= 300) {
        this.ChangableHeight = String(iCalcHeight) + "px"
      } else {
        this.ChangableHeight = "300px"
      }
    },

    // 초기화 하기
    Initialize(){
      this.bApplyDate = true;
      this.DataInit();
      this.GetCorCarryLog();
    },

    DataInit(){
      this.sStartDate = Util.sFormatDate(Util.sBefore1Moth())
      this.sEndDate = Util.sFormatDate(Util.sAfter1Moth())
      this.sNowSelectDate = Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth())
      this.sCarryStartDate = Util.sFormatDate(Util.sBefore1Moth())
      this.sCarryEndDate = Util.sFormatDate(Util.sAfter1Moth())
      this.sCarryNowSelectDate = Util.sFormatDate(Util.sBefore1Moth()) + " ~ " +  Util.sFormatDate(Util.sAfter1Moth())
      this.cNowSearchkeyWord = ""
      this.cState = "ALL"
      this.cSort = "ALL"
    },

    ShowDelDialog(item){
      this.$refs.DelDialogRef.ShowDialog("Carry",item,this.Records.indexOf(item));
    },

    DelCarryData(index,item){
      this.DelCorCarryLog(index,item)
    },

    UpdateCorCarryLog(data,index){
      this.Records[index].cLabel = data.cLabel
      this.Records[index].cZone = data.cZone
      this.Records[index].cReason = data.cReason
      this.Records[index].cSort = data.cSort
      this.Records[index].cLongReason = data.cLongReason
      this.Records[index].cCarryInDate = data.cCarryInDate
      this.Records[index].cCarryOutDate = data.cCarryOutDate
    },

    onDateRangeChange(daterange){            
      this.sStartDate = Util.sFormatDate(daterange.startDate);
      this.sEndDate = Util.sFormatDate(daterange.endDate);
      this.sNowSelectDate = this.sStartDate + " ~ " +  this.sEndDate;
      this.GetCorCarryLog();
    },

    onCarryDateRangeChange(daterange){
      this.sCarryStartDate = Util.sFormatDate(daterange.startDate);
      this.sCarryEndDate = Util.sFormatDate(daterange.endDate);
      this.sCarryNowSelectDate = this.sCarryStartDate + " ~ " +  this.sCarryEndDate;
      this.GetCorCarryLog();
    },

    getLabel(cLabel){
      return this.zCarryItem.find((e) => {return e.value == cLabel})?.text
    },

    getSort(cSort){
      return this.zCarrySort.find((e) => {return e.value == cSort})?.text
    },

    getSortColor(cSort){
      return this.zCarrySort.find((e) => {return e.value == cSort})?.color
    },

    getState(cState){
      return this.zCarryState.find((e) => {return e.value == cState})?.text
    },

    getStateColor(cState){
      return this.zCarryState.find((e) => {return e.value == cState})?.color
    },

    getElapsedDate(cCreateDateTime) {
      const date1 = new Date(cCreateDateTime.substring(0,10));

      const elapsedMSec = this.date2.getTime() - date1.getTime();
      const elapsedDay = elapsedMSec / 1000 / 60 / 60 / 24;

      if (elapsedDay >= 0) {
        return elapsedDay + "일"
      } else {
        return -elapsedDay + "일전"
      }
    },

    handleClick(value) {
      this.selected = [value];
    },

    handleDoubleClick(item){
      if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager == "N") return
      if (item.cCustomId != this.CustomInfo.CustomId && this.CustomInfo.Manager != "N" && item.cState == BasicInfo.REQ_TYPE_CARRY_STATE_REQ) return

      if (this.selected.length > 0 || item.cReqId != undefined){
        this.OpenDialog(item)
      }
    },

    async OpenDialog(item) {
      if (item.cState == BasicInfo.REQ_TYPE_CARRY_STATE_REQ) {
        let EditIndex = this.Records.indexOf(item)
        let res = await this.GetCorCarryItemLog(item);

        if (res.data.ResultCd == "00") {
          this.$refs.EditCarryDialogRef.ShowDialog(item,EditIndex,res.data.Result1,res.data.Result2)
        } else {
          EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
        }
      } else {
        this.ShowComment(item,item.cState);
      }
    },

    ShowComment(oitem,StateNm) {
      this.$refs.ResponseDialogRef.ShowDialog(oitem,this.getState(StateNm),true)
    },

    // 업체정보 가져오기
    GetCorCarryItemLog(item){
      var posData = {
        ReqId : item.cReqId,
        Label : item.cLabel,
      };
      return new Promise((resolve) => (
        axios
        .post(process.env.VUE_APP_UIL_API + "GetCorCarryItemLog", posData, {
          headers: {
            "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          resolve(res);
        })
        .catch(err => {
          resolve(err);
        })
      ))
    },

    ShowNoResultMsg() {
      this.cNoMsg = ""

      setTimeout(() => {
        this.cNoMsg = "검색된 방문자가 없습니다."
      }, 300);
    },

    GetCorCarryLog(){
      this.Records = [];

      var posData = {
        Manager : this.CustomInfo.Manager,
        CorpId : this.CustomInfo.CorpId,
        SiteId : this.CustomInfo.SiteId,
        CustomId : this.CustomInfo.CustomId,
        Sort : this.cSort,
        State : this.cState,
        StartDate : this.sStartDate,
        EndDate : this.sEndDate,
        CarryInDate : this.sCarryStartDate,
        CarryOutDate : this.sCarryEndDate,
        NowSearchKeyWord : this.cNowSearchkeyWord,
        ApplyDate : this.bApplyDate,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "GetCorCarryLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd === "00") {
            if (res.data.Result.length > 0) {
              for (let i =0; i < res.data.Result.length; i++){
                res.data.Result[i].sNum = i+1
              }
            } else {
              this.ShowNoResultMsg();
            }

            this.Records = res.data.Result
            this.bApplyDate = false
          } else if (res.data.ResultCd == BasicInfo.ERROR_CODE_CHECK_RIGHT_CUSTOM) {
            EventBus.$emit("onShowMsgBox", "정보 조회가 불가 합니다.","소속업체 또는 관리자 권한이 변경되었을 수 있습니다.\n새로고침 버튼을 눌러 주세요.");
            this.ShowNoResultMsg();
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

    DelCorCarryLog(index,item){
      var posData = {
        SiteId : this.$store.state.CustomInfo.SiteId,
        ReqId : item.cReqId,
        CorpId : this.CustomInfo.CorpId,
      };
      axios
        .post(process.env.VUE_APP_UIL_API + "DelCorCarryLog", posData, {
          headers: {
           "Authorization": this.CustomInfo.Token
          }
        })
        .then(res => {
          if (res.data.ResultCd == "44") { EventBus.$emit("onTokenExpired"); return; }
          if (res.data.ResultCd == "66") { EventBus.$emit("onChangeCorpInfo"); return; }
          if (res.data.ResultCd === "00") {
            this.Records.splice(index,1)
            for (let i = 0; i < this.Records.length;i ++){
              this.Records[i].sNum = i+1
            }
            EventBus.$emit("onShowMsg",false,"삭제가 완료되었습니다.");
          } else if (res.data.ResultCd === "04") {
            EventBus.$emit("onShowMsgBox","삭제되었거나 승인된 사항입니다.", "화면을 다시 접속 하여 확인하여 주세요.");
          } else {
            EventBus.$emit("onShowMsg",true,  "(" + res.data.ResultCd + ") " + res.data.Msg);
          }
        })
        .catch(err => {
          EventBus.$emit("onShowMsg",true, ""+err);
        });
    },

  }
}
</script>